'use client';

import { useCallback, useEffect, useState } from 'react';
import { Button, Icon, TextPassage } from '@petsmart-ui/sparky';

import { layoutEvents, trackCheckoutSignUpImpression } from '@libs/analytics';
import { AccountDrawerType, usePageLayout } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerClick });

export function SignIn() {
    const [isCartPage, setIsCartPage] = useState(false);
    const { openAccountDrawer } = usePageLayout();

    const currentPage = IS_SSR ? '' : new URL(window.location.href).pathname;

    useEffect(() => {
        setIsCartPage(['/checkout-login', '/cart'].includes(currentPage));
    }, [currentPage]);

    const redirectURL = isCartPage
        ? `${NAVIGATION_URLS.velocity.createAccount}?redirectUrl=${currentPage}`
        : NAVIGATION_URLS.velocity.createAccount;

    const handleSignInButtonClick = useCallback(() => {
        trackCheckoutSignUpImpression();
        openAccountDrawer(AccountDrawerType.SIGN_IN);
    }, [openAccountDrawer]);

    return (
        <div className="sign-in-new" data-testid="sign-in">
            <section className="signin-dropcontent">
                <div className="signin-dropcontent__container">
                    <div className="signin-dropcontent__content">
                        <TextPassage>
                            Sign in or create a Treats Rewards account to earn points on purchases!
                        </TextPassage>
                        <Button type="button" fullWidth text="Create account" href={redirectURL} />
                        <Button
                            type="button"
                            className="signin-dropcontent__button"
                            variant="primary"
                            fullWidth
                            text="Sign in"
                            onClick={handleSignInButtonClick}
                        />

                        <TextPassage className="treats-text">
                            <Icon name="treats-fill" size="sm" className="treats-fill" />
                            <span>Learn more about Treats Rewards</span>
                        </TextPassage>
                    </div>
                </div>
            </section>
        </div>
    );
}
